<template>
    <customModal :containerxxl="true" @closeModal="$emit('closeModal')">

        <template #title>
            Risk Details - {{ data?.riskId }}
        </template>

        <template #body>
            <div class="modal-content-wrapper">
                <!-- BASIC INFORMATION -->
                <div class="section-block">
                    <h6 class="border-bottom mb-0">
                        Basic Information
                    </h6>
                    <div class="row">
                        <!-- LEFT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Risk ID</strong>
                                </div>
                                <div>{{ data.riskId }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>CTQ ID</strong>
                                </div>
                                <div>{{ data.ctqId }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>CTQ Factor</strong>
                                </div>
                                <div>{{ data.ctqFactor }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Category</strong>
                                </div>
                                <div>{{ data.riskCategory }}</div>
                            </div>
                            <div class="d-flex py-1">
                                <div class="label-block">
                                    <strong>Sub Category</strong>
                                </div>
                                <div>{{ data.subCategory }}</div>
                            </div>
                        </div>

                        <!-- RIGHT -->
                        <div class="col-md-6">
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Type of Risk</strong>
                                </div>
                                <div>{{ data.typeOfRisk }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Phase</strong>
                                </div>
                                <div>{{ data.phase }}</div>
                            </div>
                            <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Level of Scrutiny</strong>
                                </div>
                                <div>{{ data.levelOfScrutiny }}</div>
                            </div>
                            <!-- <div class="d-flex border-bottom py-1">
                                <div class="label-block">
                                    <strong>Status</strong>
                                </div>
                                <div>
                                    <span v-if="data.status" class="badge"
                                        :class="data.status.toLowerCase() === 'open' ? 'badge-info' : 'badge-secondary'">{{
                                        data.status }}</span>
                                </div>
                            </div> -->
                            <div class="d-flex py-1">
                                <div class="label-block">
                                    <strong>Is Active</strong>
                                </div>
                                <div>{{ data.isActive ? 'Yes' : 'No' }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RISK DESCRIPTION -->
                <div class="section-block mt-3">
                    <h6 class="border-bottom mb-1">
                        Risk Description
                    </h6>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Risk Statement</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.riskStatement }}</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Failure Mode</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.failureMode }}</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Root Cause</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.rootCause }}</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Consequence</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.consequence }}</div>
                        </div>
                    </div>
                </div>

                <!-- SCORING -->
                <div class="section-block mt-3">
                    <h6 class="border-bottom mb-1">
                        Risk Scoring
                    </h6>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex py-1 border-bottom">
                                <div class="label-block"><strong>Probability</strong></div>
                                <div>{{ data.probability !== null ? data.probability : '-' }}</div>
                            </div>
                            <div class="d-flex py-1 border-bottom">
                                <div class="label-block"><strong>Impact</strong></div>
                                <div>{{ data.impact !== null ? data.impact : '-' }}</div>
                            </div>
                            <div class="d-flex py-1">
                                <div class="label-block"><strong>Detectability</strong></div>
                                <div>{{ data.detectability !== null ? data.detectability : '-' }}</div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="d-flex py-1 border-bottom">
                                <div class="label-block"><strong>RPN</strong></div>
                                <div><strong>{{ data.rpn !== null ? data.rpn : '-' }}</strong></div>
                            </div>
                            <div class="d-flex py-1 border-bottom">
                                <div class="label-block"><strong>Risk Level</strong></div>
                                <div><span v-if="data.riskLevel" :class="riskLevelBadgeClass(data.riskLevel)">{{
                                        data.riskLevel }}</span></div>
                            </div>
                            <div class="d-flex py-1">
                                <div class="label-block"><strong>Scoring Status</strong></div>
                                <div>{{ data.scoringStatus }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RESIDUAL SCORING -->
                <div class="section-block mt-3">
                    <h6 class="border-bottom mb-1">
                        Residual Risk
                    </h6>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="d-flex py-1 border-bottom">
                                <div class="label-block"><strong>Residual RPN</strong></div>
                                <div><strong>{{ data.residualRpn !== null ? data.residualRpn : '-' }}</strong></div>
                            </div>
                            <div class="d-flex py-1">
                                <div class="label-block"><strong>Residual Risk Level</strong></div>
                                <div><span v-if="data.residualRiskLevel"
                                        :class="riskLevelBadgeClass(data.residualRiskLevel)">{{ data.residualRiskLevel
                                        }}</span></div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="label-block mb-1"><strong>Score Rationale</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.scoreRationale }}</div>
                        </div>
                    </div>
                </div>

                <!-- CONTROL & MITIGATION -->
                <div class="section-block mt-3">
                    <h6 class="border-bottom mb-1">
                        Control & Mitigation
                    </h6>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Risk Owner</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.riskOwner }}</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <div class="label-block mb-1"><strong>Execution Type</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.executionType }}</div>
                        </div>
                        <div class="col-md-12 mb-2">
                            <div class="label-block mb-1"><strong>Detection Method</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.detectionMethod }}</div>
                        </div>
                        <div class="col-md-12 mb-2">
                            <div class="label-block mb-1"><strong>Objectives</strong></div>
                            <div class="border rounded px-3 py-1 bg-light">{{ data.objectives }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </customModal>
</template>

<script src="./ViewRiskInfoModal.js"></script>

<style scoped>
.section-block h6 {
    font-size: .9rem !important;
    font-weight: 600 !important;
    margin-bottom: 4px;
    color: #3d4b63;
}

.label-block {
    min-width: 180px;
}

.modal-content-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    padding-right: 4px;
}

.badge {
    padding: 3px 12px;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 500;
    display: inline-block;
    white-space: nowrap;
}

.badge-success {
    background-color: #d4edda;
    color: #155724;
}

.badge-warning {
    background-color: #fff3cd;
    color: #856404;
}

.badge-info {
    background-color: #d1ecf1;
    color: #0c5460;
}

.badge-secondary {
    background-color: #e2e3e5;
    color: #383d41;
}
</style>
